import type { LoaderFunction } from 'react-router-dom';
import { apiGetBestWrestlerWomanListStats } from "../../components/ui_components/ApiList";

export const BestWomansWrestlerResposiveLoader: LoaderFunction = async ({ request }) => {
    try {
        const url = new URL(request.url);
        const year = url.searchParams.get('year') || 'globale';

        const response = await apiGetBestWrestlerWomanListStats(1, year, '', true);
        return response;
    } catch (error) {
        console.error('Loader error:', error);
        throw new Error('Failed to load data');
    }
};
